var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZiehlAbegg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1354 290.3",
    style: {
      enableBackground: "new 0 0 1354 290.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Gr\xFCn_x0020_bogenf\xF6rmig{fill:url(#SVGID_1_);stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:1;}\r\n\t.st0{fill:#004494;}\r\n\t.st1{fill:#CFAB28;}\r\n\t.st2{opacity:0.6;fill:url(#SVGID_00000075877889106716303200000008896170283092965549_);}\r\n\t.st3{opacity:0.25;fill:url(#SVGID_00000171705508090755029410000004026656044751211681_);}\r\n\t.st4{opacity:0.4;fill:url(#SVGID_00000153679721583225882410000003332425214621196697_);}\r\n\t.st5{opacity:0.5;}\r\n\t.st6{opacity:0.5;fill:#FFFFFF;}\r\n\t.st7{opacity:0.34;fill:url(#SVGID_00000040549109753368782460000004738691439764119731_);}\r\n\t.st8{opacity:0.53;}\r\n\t.st9{opacity:0.53;fill:url(#SVGID_00000111887225889300550320000010681948912173772467_);}\r\n\t.st10{opacity:0.43;fill:#FFFFFF;}\r\n\t.st11{opacity:0.42;fill:url(#SVGID_00000000211399603418852000000007151017882860004739_);}\r\n\t.st12{opacity:0.54;}\r\n\t.st13{opacity:0.4;fill:url(#SVGID_00000027581060441955838820000012742013306746947488_);}\r\n\t.st14{opacity:0.53;fill:#F6F6F6;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 512.0845,
    y1: 781.2813,
    x2: 512.7916,
    y2: 780.5742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#259E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#1C381D"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1068.1,152c-18.7,0-33.9,5-45.7,15.1c-11.7,10-17.6,23-17.6,39c0,15.6,5.9,28.4,17.6,38.5 c11.8,10.1,26.8,15.1,45.1,15.1c8.3,0,16.7-1.3,25.2-3.9c8.5-2.6,14.8-6,19-10.2v-42.9h-41.4v19.2h15.2v12.3 c-5.8,2.5-11.6,3.8-17.4,3.8c-10.9,0-19.6-2.9-26.3-8.6c-6.7-5.7-10-13.2-10-22.4c0-9.6,3.3-17.5,10-23.7 c6.7-6.2,16.2-9.3,28.5-9.3c12.8,0,25.9,3.2,39.2,9.7v-22.9C1097.3,154.9,1083.5,152,1068.1,152 M948.5,152 c-18.7,0-33.9,5-45.7,15.1c-11.8,10-17.6,23-17.6,39c0,15.6,5.9,28.4,17.6,38.5c11.8,10.1,26.8,15.1,45.1,15.1 c8.3,0,16.7-1.3,25.2-3.9c8.5-2.6,14.8-6,19-10.2v-42.9h-41.4v19.2h15.2v12.3c-5.8,2.5-11.6,3.8-17.4,3.8 c-10.9,0-19.6-2.9-26.3-8.6c-6.7-5.7-10-13.2-10-22.4c0-9.6,3.3-17.5,10-23.7c6.7-6.2,16.2-9.3,28.5-9.3c12.8,0,25.9,3.2,39.2,9.7 v-22.9C977.8,154.9,964,152,948.5,152 M740.3,214.3c4.9,0,8.7,1.1,11.7,3.2c2.9,2.1,4.4,5,4.4,8.7c0,4.8-1.5,8.1-4.6,10 c-3.1,1.9-8.1,2.9-15,2.9h-14.7v-24.8H740.3z M735.6,172.6c4.2,0,7.5,1.1,9.9,3.2c2.4,2.1,3.5,4.8,3.5,8c0,3.3-1.2,6-3.5,8.1 c-2.4,2.2-5.6,3.2-9.9,3.2h-13.7v-22.5H735.6z M695.8,258.4h51.1c12.2,0,21.4-2.9,27.7-8.6c6.3-5.7,9.4-13.1,9.4-22.3 c0-6.4-1.9-12-5.8-16.9c-3.8-4.8-9.4-8.2-16.6-10.1c9.6-4.9,14.4-11.8,14.4-21c0-7.1-3.1-13.3-9.3-18.5c-6.2-5.2-14.7-7.8-25.5-7.8 h-45.4V258.4z M609.2,215.8l14-37.3l15.3,37.3H609.2z M607.6,153.3l-42.4,105H593l8.6-23h45.1l9.8,23h28.1l-46.6-105H607.6z  M516,215.8h40.1v-19.6H516V215.8z M450.6,239.1v-85.8h-26.2v105l80,0v-19.2L450.6,239.1z M377.3,153.3v42.8H325v-42.8h-26.2v105 H325v-42.5h52.3v42.5h26.2v-105H377.3z M227.5,239.1v-23.6h47.9v-19.2h-47.9v-23.7h50.2v-19.2h-76.4v105h77.4v-19.2H227.5z  M154.8,258.4H181v-105h-26.2V258.4z M36.2,153.3v19.2h53.7l-57.7,85.8h101.9v-19.2H76.9l57.3-85.8H36.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "824.2,238.9 824.2,215.3 872.1,215.3 872.1,196.1 824.2,196.1 824.2,172.4 874.4,172.4 874.4,153.1  798.1,153.1 798.1,258.1 875.5,258.1 875.5,238.9  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1322.7,261 1235.5,137.7 1225.3,152 1205.2,136.7 1300.5,80.7 1234.2,30.6 1234.2,64.6 1252.5,78  1157.4,133.9 1209.9,173.8 1148.2,261  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070806166650354802410000003060125654090273421_",
    gradientUnits: "userSpaceOnUse",
    x1: 1174.3282,
    y1: 206.4627,
    x2: 1275.8928,
    y2: 206.4386,
    gradientTransform: "matrix(1.4449 -0.1008 6.960000e-02 0.9976 -541.2845 119.6374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000070806166650354802410000003060125654090273421_)"
    },
    points: "1211.1,173.7  1173.6,260.1 1321,260.1 1235.5,139.2 1225.5,153.2 1211.1,142.2  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013194672508518859480000005041432061481053320_",
    cx: 1528.3267,
    cy: 49.8419,
    r: 61.1632,
    gradientTransform: "matrix(-5.312732e-02 -0.3807 0.6255 -7.261608e-02 1317.4021 813.369)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6788,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000013194672508518859480000005041432061481053320_)"
    },
    d: "M1284.5,226.2 c1.7,17.2-4.6,31.9-14,32.8c-9.4,0.9-18.4-12.2-20.1-29.4c-1.7-17.2,4.6-31.9,14-32.8C1273.8,195.9,1282.8,209.1,1284.5,226.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178191143098099884310000000582228133121180826_",
    gradientUnits: "userSpaceOnUse",
    x1: 1207.485,
    y1: 83.4534,
    x2: 1298.644,
    y2: 77.079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0787879,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    style: {
      stopColor: "#F6F6F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6F6F6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000178191143098099884310000000582228133121180826_)"
    },
    points: "1254.1,78  1210.9,103.5 1210.9,132.3 1298.9,80.6 1235.1,32.4 1235.1,64.2  "
  }), /*#__PURE__*/React.createElement("g", null, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1235.1,64.2 1234.2,64.6 1252.5,78 1254.1,78  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1234.2,30.6 1235.1,32.4 1235.1,64.2 1234.2,64.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084505545858155175390000004689326854544254859_",
    gradientUnits: "userSpaceOnUse",
    x1: 1234.2329,
    y1: 55.6697,
    x2: 1300.4595,
    y2: 55.6697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.34,
      fill: "url(#SVGID_00000084505545858155175390000004689326854544254859_)"
    },
    points: "1300.5,80.7  1234.2,30.6 1235.1,32.4 1298.9,80.6  "
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "1300.5,80.7 1205.2,136.7 1203.7,136.6 1298.9,80.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131368406579804798520000015008136393028249251_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.6646,
    y1: 144.8919,
    x2: 1225.4956,
    y2: 144.8919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.53,
      fill: "url(#SVGID_00000131368406579804798520000015008136393028249251_)"
    },
    points: "1225.3,152  1225.5,153.2 1203.7,136.6 1205.2,136.7  "
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1235.5,139.2 1235.5,137.7 1225.3,152 1225.5,153.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172439896509681458190000011899081655990482110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1235.5327,
    y1: 199.3351,
    x2: 1322.7339,
    y2: 199.3351
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.42,
      fill: "url(#SVGID_00000172439896509681458190000011899081655990482110_)"
    },
    points: "1322.7,261  1321,260.1 1235.5,139.2 1235.5,137.7  "
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "1149.9,260.1 1148.2,261 1322.7,261 1321,260.1  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1149.9,260.1 1148.2,261 1209.9,173.8 1211.1,173.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181061355782486694100000013938133681834161282_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.4448,
    y1: 153.8511,
    x2: 1211.0649,
    y2: 153.8511
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000181061355782486694100000013938133681834161282_)"
    },
    points: "1211.1,173.7  1209.9,173.8 1157.4,133.9 1159,134  "
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "1159,134 1157.4,133.9 1252.5,78 1254.1,78  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZiehlAbegg);
export default __webpack_public_path__ + "static/media/ziehl-abegg.b21b08635951bd2e77642276b380253f.svg";
export { ForwardRef as ReactComponent };